const TYPING_TARGET_SELECTOR = [
  "input",
  "textarea",
  "select",
  "[role='textbox']",
  "[role='combobox']",
  "[role='listbox']",
  "[role='option']",
  "[contenteditable]:not([contenteditable='false'])",
].join(", ")

function getTargetElement(target: EventTarget | null): Element | null {
  if (target instanceof Element) {
    return target
  }

  if (target instanceof Node) {
    return target.parentElement
  }

  return null
}

export function isKeyboardTypingTarget(target: EventTarget | null): boolean {
  const element = getTargetElement(target)

  if (!element) {
    return false
  }

  if (element instanceof HTMLElement && element.isContentEditable) {
    return true
  }

  return element.closest(TYPING_TARGET_SELECTOR) !== null
}
